module.exports = __webpack_public_path__ + "static/media/icon-food.aec0af0e.png";